<template>
  <transition name="dialog" appear>
    <div class="dialog-mask" @click="close">
      <div class="dialog-wrapper">
        <div class="dialog-container" @click.stop="" :style="{width: dialogWidth}">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="less" scoped>
  .dialog-mask{
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
    .dialog-wrapper{
      display: table-cell;
      vertical-align: middle;
      .dialog-container{
        width: 80%;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 14px 0 rgba(75,119,174,0.25);
        overflow: hidden;
        transition: all .3s ease;
      }
    }
  }
  // 动画
  .dialog-enter {
    opacity: 0;
  }

  .dialog-leave-active {
    opacity: 0;
  }

  .dialog-enter .dialog-container,
  .dialog-leave-active .dialog-container {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      header: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: '警告',
      },
      closeOnClickModal: {
        type: Boolean,
        default: true,
      },
      dialogWidth: {
        type: String
      }
    },
    data() {
      return {}
    },
    methods: {
      close() {
        if(!this.closeOnClickModal) return;
        this.$emit('close')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/dialog.vue